// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"419a5d54","549":"50aa4cfb","781":"7692f188","850":"2da130a1"}[chunkId] + ".chunk.js";
};